import moment from "moment";

moment.locale("es");

/**
 * Determines the financial year based on the current month.
 * JAN - JUN (actual year - 1)
 * JUL - DIC (actual year)
 */
export const determineFinancialYear = () => {
  let date = moment();
  let monthNumber = date.format("M");
  let year = date.year();
  let lastYear = date.year() - 1;

  return monthNumber > 6 ? year : lastYear;
};

/**
 * Return date Safelly
 * @param {moment.MomentInput} date
 * @returns {string} Date in format "DD-MM-YYYY"
 */
export const getFormatedDate = (date) => {
  try {
    return moment(date).format("DD-MM-YYYY");
  } catch (e) {
    return date;
  }
};
